import React from "react"
import { navigate } from "gatsby"
import NavigationLogo from "./components/NavigationLogo/NavigationLogo"
import Hamburger from "./components/Hamburger/Hamburger"
import { listItems } from "../../types/listItems"
import ListItem from "./components/ListItem/ListItem"
import { PageRoutesMap } from "../../types/routes"

const MobileNav = () => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isSubListsOpen, setIsSubListsOpen] = React.useState<boolean[]>(
    Object.keys(PageRoutesMap).map(_ => false)
  )

  const handleSubListOpen = (index: number) => {
    const newArr = isSubListsOpen.map((item, i) => (i === index ? !item : item))
    setIsSubListsOpen([...newArr])
  }

  return (
    <>
      <div className="flex justify-start relative h-12">
        <Hamburger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
        <NavigationLogo onClick={() => navigate("/")} />
      </div>
      <div
        className={`pb-12 no-scrollbar overflow-scroll fixed z-20 top-12 w-full h-full bg-inherit transform transition-all duration-500 ${
          isOpen ? "" : "-translate-x-full"
        }`}
      >
        <ul className="flex flex-col list-none items-center pt-14 gap-4">
          {listItems.map((item, i) => (
            <ListItem
              key={i}
              section={item.section}
              onClick={() => handleSubListOpen(i)}
              isOpen={isSubListsOpen[i]}
            >
              {item.label}
            </ListItem>
          ))}
        </ul>
      </div>
    </>
  )
}

export default MobileNav
